import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#F5F0E8] pt-12 pb-20 lg:pt-24 lg:pb-32 overflow-hidden" data-id="element-109">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-110">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-111">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left z-10" data-id="element-112">
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-[#C17F6B]/10 text-[#C17F6B] font-semibold text-sm tracking-wide uppercase" data-id="element-113">
              Para mujeres de 45+
            </div>

            <h1 className="text-4xl lg:text-6xl font-serif font-bold text-[#3D4852] leading-tight mb-6" data-id="element-114">
              ¿Tu cuerpo cambió de reglas después de los 45?
            </h1>

            <p className="text-lg lg:text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-115">
              Descubre el{' '}
              <span className="font-semibold text-[#C17F6B]" data-id="element-116">
                Protocolo 21 Días
              </span>{' '}
              para desinflamar tu abdomen, controlar antojos y recuperar energía
              — sin dietas extremas ni cardio castigo.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-117">
              <a href="#precio" onClick={e => {
              e.preventDefault();
              document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto px-8 py-4 bg-[#C17F6B] hover:bg-[#A96B58] text-white text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 group cursor-pointer" data-id="element-118">
                Quiero el Protocolo
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-119" />
              </a>
              <div className="flex flex-col items-center sm:items-start" data-id="element-120">
                <div className="flex items-center gap-2" data-id="element-121">
                  <span className="text-xs font-semibold text-white bg-[#C17F6B] px-2 py-0.5 rounded-full" data-id="element-122">
                    76% OFF
                  </span>
                </div>
                <span className="text-2xl font-bold text-[#C17F6B]" data-id="element-123">
                  $6.39 USD
                </span>
                <span className="text-sm text-gray-500 line-through" data-id="element-124">
                  $27 USD
                </span>
              </div>
            </div>

            <p className="mt-6 text-sm text-gray-500 flex items-center justify-center lg:justify-start gap-2" data-id="element-125">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-126"></span>
              Acceso inmediato • PDF Digital
            </p>
          </div>

          {/* Image */}
          <div className="flex-1 relative w-full max-w-md lg:max-w-full" data-id="element-127">
            <div className="absolute inset-0 bg-[#8B9A7D]/20 rounded-full blur-3xl transform scale-90 translate-y-10" data-id="element-128"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2kG79Ta5XcutxoBrnEhRxh/thumb.png" alt="Menopausia Sin Barriga eBook en tablet" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-129" />
          </div>
        </div>
      </div>
    </section>;
}